import './CompaniesIndustry.scss'
import { Table } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCompany from 'hook/useCompany';
import TableListCompany from './TableListCompany';
import { setLoading } from 'store/actionReducers/LoadingStore';
import { setCompanySame } from 'store/actionReducers/CompanyStore';

interface DataType {
  key: React.Key;
  code: string;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

export default function CompaniesIndustry() {
  const dispatch = useDispatch();
  const { fetchCompanySame } = useCompany();
  const [filter, setFilter] = useState({ stock: '', page: 0, size: 10 })
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const CompanyStore = useSelector((state: any) => state?.CompanyStore)

  useEffect(() => {
    dispatch(setCompanySame([]))
    setFilter({ stock: StocksAnalysisStore?.inputSearch, page: 0, size: 10 })
  }, [StocksAnalysisStore?.inputSearch]);

  useEffect(() => {
    fetchCompanySame(filter);
  }, [filter])

  const loadMoreData = () => {
    setFilter({ ...filter, page: filter?.page + 1 })
  }

  return (
    <>
      <div className='cRRMAySYfA'>
        <div className='zQVtXwrBph'>Các công ty cùng ngành</div>
        <div className='nuZpjmmcmg'>
          <TableListCompany data={CompanyStore?.companySame} LoadMoreData={() => loadMoreData()} />
        </div>
      </div>
    </>
  )
}